import { render, staticRenderFns } from "./SIngleDay.vue?vue&type=template&id=458a764a&scoped=true&"
import script from "./SIngleDay.vue?vue&type=script&lang=js&"
export * from "./SIngleDay.vue?vue&type=script&lang=js&"
import style0 from "./SIngleDay.vue?vue&type=style&index=0&id=458a764a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a764a",
  null
  
)

export default component.exports